import React from 'react';
import {
  StyledDropDown,
  appFormUtil
} from 'modules';
import * as ds from './dataService';


export type SelectStandardTemplateMilestoneFieldProps<T extends object> = appFormUtil.SelectFieldProps<T> & {
  disabled?: boolean;
  inputLabel?: string;
};

export const FC = <T extends object>(props: SelectStandardTemplateMilestoneFieldProps<T>) => {
  const { data } = ds.useQuery();

  return (
    <StyledDropDown.FC
      inputLabel={props.inputLabel ? props.inputLabel : undefined}
      {...props.form.genFieldProps(props.fieldName)}
      options={data}
      disabled={props.disabled}
    />
  );
};
